import React from 'react'
import {
    TEMPLATE_STATUS,
    TEMPLATE_STATUS_LABELS,
    TemplateStatus,
} from '../../../../domain/entities/TemplateStatus'

interface Props {
    status?: TemplateStatus
    label?: string
    className?: string
}

const variants: Record<TemplateStatus, string> = {
    [TEMPLATE_STATUS.DRAFT]: 'bg-[#FFF3E6] text-[#CC6D02]',
    [TEMPLATE_STATUS.ACTIVE]: 'bg-[#E6F7F1] text-[#00875A]',
    [TEMPLATE_STATUS.DEACTIVATED]: 'bg-[#F1F5F9] text-[#3E5060]',
}

export function TemplateStatusBadge({ status, label, className = '' }: Props) {
    if (!status) return null

    return (
        <span
            data-testid={`template-status-${status}`}
            className={`inline-flex items-center px-2 py-1 rounded-full text-xs font-medium ${variants[status]} ${className}`}
        >
            {label ?? TEMPLATE_STATUS_LABELS[status]}
        </span>
    )
}
